import { combineReducers } from 'redux';
import valuesReducer from '../features/values/values-slice';
import modelReducer from '../features/model/model-slice';
import progressReducer from '../features/progress/progress-slice';
import { potterwareFileReducer } from '../features/values/potterware-file';

export default combineReducers({
  values: valuesReducer,
  model: modelReducer,
  potterwareFile: potterwareFileReducer,
  progress: progressReducer,
});
